<template>
  <main>
    <Trail />
    <Container class="container--main">
      <Row>
        <ColumnUi md="9">
          <template v-if="monitoring">
            <Title tag="h1" v-if="monitoring">Monitoreo y Pronóstico</Title>
            <Title tag="h2" theme="primary" v-if="monitoring">
              {{ monitoring.title }}
            </Title>
          </template>
          <Title tag="h1" v-else>Monitoreo y Pronóstico</Title>
          <Content v-if="content" :content="content" />
          <div v-else>
            <p>
              <Prognostic />
            </p>
          </div>
        </ColumnUi>
        <ColumnUi md="3">
          <div>
            <Title tag="h3" theme="normal"><b>En esta sección</b></Title>
            <List marked>
              <li v-for="(mon, index) in m" :key="index">
                <router-link
                  v-if="
                    (!monitoring && mon.slug != '') ||
                      (mon.slug != '' && monitoring.slug != mon.slug)
                  "
                  :to="`/monitoreo-pronostico/${mon.slug}`"
                >
                  {{ mon.title }}
                </router-link>
                <a
                  v-else-if="mon.slug != ''"
                  style="text-decoration: underline; pointer-events: none;"
                >
                  {{ mon.title }}
                </a>
                <span v-else class="is-muted">
                  {{ mon.title }}
                </span>
              </li>
            </List>
          </div>
          <div v-if="monitoring">
            <template
              v-for="(list, index) in monitoring.bulletins"
              :key="index"
            >
              <ItemList :list="list.data" :title="list.year.toString()" />
            </template>
          </div>
        </ColumnUi>
      </Row>
    </Container>
  </main>
</template>
<script>
import { getMonitoring } from "@/monitoring.js";
import Container from "@/components/ui/objects/Container";
import List from "@/components/ui/objects/List.vue";
import Row from "@/components/ui/atoms/Row.vue";
import ColumnUi from "@/components/ui/atoms/ColumnUi.vue";
import Trail from "@/components/common/Trail.vue";
import Title from "@/components/ui/atoms/Title.vue";
import { useRoute } from "vue-router";
import Content from "@/components/common/Content.vue";
import ItemList from "@/components/common/ItemList.vue";
import Prognostic from "@/components/common/Prognostic/Prognostic";
export default {
  components: {
    Trail,
    Container,
    Row,
    ColumnUi,
    List,
    Title,
    Content,
    ItemList,
    Prognostic
  },
  setup() {
    const m = getMonitoring(process.env.VUE_APP_PREFIX);
    const route = useRoute().params.monitoring;
    const monitoring = m.find(
      monitoring => route != "" && monitoring.slug == route
    );
    const content = monitoring && monitoring.content;

    return {
      monitoring,
      content,
      m
    };
  }
};
</script>
